/*
=========================================================
ASSABOOR ENTERPRISE
MAIN CART PAGE V2
File: assets/ae-cart-page.js
=========================================================
*/

(() => {
    'use strict';

    class AEMainCart {

        constructor(root) {

            this.root = root;

            if (!this.root) {
                return;
            }

            this.isLoading = false;
            this.noteTimer = null;

            this.bindEvents();

        }

        bindEvents() {

            this.root.addEventListener('click', (event) => {

                if (this.isLoading) {
                    return;
                }

                const item = event.target.closest(
                    '[data-ae-page-cart-item]'
                );

                if (!item) {
                    return;
                }

                const key = item.dataset.key;

                const input = item.querySelector(
                    '[data-ae-page-qty-input]'
                );

                if (!key || !input) {
                    return;
                }

                let quantity = parseInt(
                    input.value,
                    10
                );

                if (isNaN(quantity)) {
                    quantity = 1;
                }

                if (
                    event.target.closest(
                        '[data-ae-page-qty-minus]'
                    )
                ) {

                    event.preventDefault();

                    this.changeItem(
                        key,
                        Math.max(0, quantity - 1)
                    );

                    return;

                }

                if (
                    event.target.closest(
                        '[data-ae-page-qty-plus]'
                    )
                ) {

                    event.preventDefault();

                    this.changeItem(
                        key,
                        quantity + 1
                    );

                    return;

                }

                if (
                    event.target.closest(
                        '[data-ae-page-cart-remove]'
                    )
                ) {

                    event.preventDefault();

                    this.changeItem(
                        key,
                        0
                    );

                }

            });

            this.root.addEventListener(
                'change',
                (event) => {

                    if (
                        !event.target.matches(
                            '[data-ae-page-qty-input]'
                        )
                    ) {
                        return;
                    }

                    const item =
                        event.target.closest(
                            '[data-ae-page-cart-item]'
                        );

                    if (!item) {
                        return;
                    }

                    const quantity = Math.max(
                        0,
                        parseInt(
                            event.target.value,
                            10
                        ) || 0
                    );

                    event.target.value = quantity;

                    this.changeItem(
                        item.dataset.key,
                        quantity
                    );

                }
            );

            const note =
                this.root.querySelector(
                    '#AE-CartNote'
                );

            if (note) {

                note.addEventListener(
                    'input',
                    () => {

                        clearTimeout(
                            this.noteTimer
                        );

                        this.noteTimer =
                            setTimeout(
                                () => {

                                    this.updateNote(
                                        note.value
                                    );

                                },
                                500
                            );

                    }
                );

            }

        }

        setLoading(state) {

            this.isLoading = state;

            this.root.classList.toggle(
                'is-loading',
                state
            );

            this.root
                .querySelectorAll(
                    'button,input'
                )
                .forEach((element) => {

                    element.disabled = state;

                });

        }

        async changeItem(
            key,
            quantity
        ) {

            this.setLoading(true);

            try {

                const response =
                    await fetch(
                        window.Shopify.routes.root +
                        'cart/change.js',
                        {
                            method: 'POST',
                            headers: {
                                'Content-Type':
                                    'application/json',
                                Accept:
                                    'application/json'
                            },
                            body: JSON.stringify({
                                id: key,
                                quantity
                            })
                        }
                    );

                const cart =
                    await response.json();

                if (!response.ok) {

                    throw new Error(
                        cart.description ||
                        cart.message ||
                        'Unable to update cart.'
                    );

                }

                await this.refresh(cart);

                document.dispatchEvent(
                    new CustomEvent(
                        'ae:cart:added',
                        {
                            detail: {
                                title:
                                    quantity === 0
                                        ? 'Item removed from cart'
                                        : 'Cart updated successfully',
                                meta:
                                    quantity === 0
                                        ? ''
                                        : `Quantity: ${quantity}`
                            }
                        }
                    )
                );

            } catch (error) {

                console.error(
                    error
                );

                alert(
                    error.message
                );

            }

            this.setLoading(false);

        }

        async updateNote(
            note
        ) {

            try {

                await fetch(
                    window.Shopify.routes.root +
                    'cart/update.js',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type':
                                'application/json',
                            Accept:
                                'application/json'
                        },
                        body: JSON.stringify({
                            note
                        })
                    }
                );

            } catch (error) {

                console.error(
                    error
                );

            }

        }

        async refresh(
            cart = null
        ) {

            const response =
                await fetch(
                    window.location.pathname +
                    '?section_id=main-cart'
                );

            const html =
                await response.text();

            const documentHTML =
                new DOMParser()
                    .parseFromString(
                        html,
                        'text/html'
                    );

            const replacement =
                documentHTML.querySelector(
                    '[data-ae-main-cart]'
                );

            if (!replacement) {

                window.location.reload();

                return;

            }

            this.root.replaceWith(
                replacement
            );

            window.aeMainCart =
                new AEMainCart(
                    replacement
                );

            if (!cart) {

                const cartResponse =
                    await fetch(
                        window.Shopify.routes.root +
                        'cart.js'
                    );

                cart =
                    await cartResponse.json();

            }

            document
                .querySelectorAll(
                    '[data-ae-cart-count]'
                )
                .forEach(
                    (
                        element
                    ) => {

                        element.textContent =
                            cart.item_count;

                        element.hidden =
                            cart.item_count ===
                            0;

                    }
                );

            document
                .querySelectorAll(
                    '[data-ae-cart-subtotal]'
                )
                .forEach(
                    (
                        element
                    ) => {

                        element.textContent =
                            this.formatMoney(
                                cart.total_price
                            );

                    }
                );

            document.dispatchEvent(
                new CustomEvent(
                    'ae:cart:updated',
                    {
                        detail:
                            cart
                    }
                )
            );

        }

        formatMoney(
            cents
        ) {

            const amount =
                (
                    Number(
                        cents
                    ) || 0
                ) / 100;

            const currency =
                window.Shopify?.currency
                    ?.active ||
                'USD';

            try {

                return new Intl.NumberFormat(
                    'en-US',
                    {
                        style:
                            'currency',
                        currency
                    }
                ).format(
                    amount
                );

            } catch {

                return (
                    currency +
                    ' ' +
                    amount.toFixed(
                        2
                    )
                );

            }

        }

    }

    document.addEventListener(
        'DOMContentLoaded',
        () => {

            const root =
                document.querySelector(
                    '[data-ae-main-cart]'
                );

            if (!root) {
                return;
            }

            window.aeMainCart =
                new AEMainCart(
                    root
                );

        }
    );

})();